import auth from '@/middleware/auth'

export default [
  {
    path: '/mis-creditos',
    name: 'mis-creditos',
    component: () => import('@/views/MisCreditos.vue'),
    meta: {
      middleware: auth
    }
  },
  {
    path: '/mi-perfil',
    name: 'mi-perfil',
    component: () => import('@/views/MyProfile.vue'),
    meta: {
      title: 'Mi perfil',
      middleware: auth
    }
  },
  {
    path: '/cambiar-contrasena',
    name: 'cambiar-contrasena',
    component: () => import('@/views/ChangePassword.vue'),
    meta: {
      title: 'Cambiar contraseña',
      middleware: auth
    }
  },
  {
    path: '/tips',
    name: 'tips',
    component: () => import('@/views/Payments.vue'),
    meta: {
      title: 'Tips',
      middleware: auth
    }
  },
  {
    path: '/ayuda',
    name: 'ayuda',
    component: () => import('@/views/Help.vue'),
    meta: {
      title: 'Ayuda',
      middleware: auth
    }
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: () => import('@/views/Contact.vue'),
    meta: {
      title: 'Contacto',
      middleware: auth
    }
  },
  {
    path: '/blog',
    name: 'blogs',
    component: () => import('@/views/Blog.vue'),
    meta: {
      title: 'Blog',
      middleware: auth
    }
  },
  {
    path: '/blog/entrada/:id',
    name: 'blogs_entrada',
    component: () => import('@/views/BlogEntrada.vue'),
    meta: {
      title: 'Entrada',
      middleware: auth
    }
  },
  {
    path: '/pre-avatar',
    name: 'pre-avatar',
    component: () => import('@/views/PreAvatar.vue'),
    meta: {
      title: 'Avatar',
      middleware: auth
    }
  },
  {
    path: '/avatar',
    name: 'avatar',
    component: () => import('@/views/Avatar.vue'),
    meta: {
      title: 'Avatar',
      middleware: auth
    }
  },
  {
    path: '/open-banking',
    name: 'open_banking',
    component: () => import('@/views/OpenBanking.vue'),
    meta: {
      title: 'Open Banking',
      middleware: auth
    }
  }
]